/* eslint-disable import/no-internal-modules */
import formatDateInLocalTimezone from '@insided/shared/utils/dateFormatting'
import UserAvatar from '@insided/deprecated-preact-components/User/UserAvatar'
import AnonymousUserCell from '@insided/deprecated-control/overview/cells/AnonymousUserCell'

const createActionByUserCell = (accessor: string) => {
  return (props: any) => {
    const actionByUser = props[accessor]

    if (!actionByUser) {
      return null
    }

    const date = formatDateInLocalTimezone(actionByUser[Object.keys(actionByUser)[0]])
    const user = actionByUser[Object.keys(actionByUser)[1]]
    const { id, username, avatar } = user
    const url = `/member/profile?userid=${id}`

    return (
      <div className='overview__table-last-action-by-user'>
        <div className='overview__table-last-action-by-user-date'>{`${date} by `}</div>
        {!username ? (
          <AnonymousUserCell customClass='overview__table-last-action-by-user' />
        ) : (
          <div className='flex-center'>
            <UserAvatar
              user={{
                id,
                name: username,
                avatar,
                url: url
              }}
              openInNewTab
              style={{ width: '16px', height: '16px' }}
            />
            <a href={url} target='_blank' rel='noreferrer'>
              {username}
            </a>
          </div>
        )}
      </div>
    )
  }
}

export default createActionByUserCell
